module.exports = __webpack_public_path__ + "img/member-verify-icon-4.dc26f100.png";